// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-cyber-sec>h2{font-size:var(--fs-600);margin-bottom:calc(var(--fs-700)*1.5)}.c-cyber-sec>h3{font-size:var(--fs-500);margin:var(--fs-700) 0}.c-cyber-sec>p,.c-cyber-sec a{font-size:var(--fs-400)}.c-cyber-sec a{color:#000}.c-cyber-sec u{display:block;padding-bottom:var(--fs-500)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
